import cn from 'classnames'

import { useCallback, useEffect, useState } from 'react'

import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import ButtonBlue from '../../../components/ui/button/_color/_blue'

import { useAppSelector } from '../../../store/hooks'

import { LoginStatuses, selectedAuthStatus } from '../../../store/reducers/users'

import styles from './styles.module.scss'

import Block1Img from './images/block1.svg'
import Block2Img from './images/block2.svg'
import Block3Img from './images/block3.svg'
import Block3ImgMobile from './images/block3_mobile.svg'
import Block4Img from './images/block4.svg'

import Block1Icon from './icons/block1.svg'
import Block2Icon from './icons/block2.svg'
import Block3Icon from './icons/block3.svg'
import Block4Icon from './icons/block4.svg'
import { useTranslation } from 'utils/use-translation'

const LoginForm = dynamic(() => import('../../../components/ui/header/components/popup-login-form'), { ssr: false })

const POPUP_TYPE_LOANS = 'loans'

export default function WhyCoinrabbit() {
  const { t, locale } = useTranslation()

  const [windowWidth, setWindowWidth] = useState(0)

  const [isOpenLoginBlock, setIsOpenLoginBlock] = useState(false)

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const handleClosePopup = useCallback(() => {
    setIsOpenLoginBlock(false)
  }, [])

  useEffect(() => {
    if (window) {
      setWindowWidth(window.innerWidth)
    }
  }, [])

  const getStarted = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/exchange',
      })
    } else {
      setIsOpenLoginBlock(true)
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={cn(styles.wrapper__item, styles.wrapper__item_first)}>
        <div className={styles.wrapper__item__content}>
          <div className={styles.wrapper__item__content__header}>
            <img src={Block1Icon} alt="block 1 icon" />
            <h3 className={styles.margin}>
              <span className={styles.wrapper__item__span1}>240+</span> {t('cryptocurrencies')}
            </h3>
          </div>
          <p>{t('cryptocurrencies_available')}</p>
          <ButtonBlue disableHoverColor className={styles.wrapper__item__content__btn} onClick={getStarted}>
            {t('get_started')}
          </ButtonBlue>
        </div>

        <img className={styles.wrapper__item__image} src={Block1Img} alt="block 1 image" />
      </div>

      <div className={cn(styles.wrapper__item, styles.wrapper__item_first)}>
        <img className={styles.wrapper__item__image} src={Block2Img} alt="block 2 image" />

        <div className={styles.wrapper__item__content}>
          <div className={styles.wrapper__item__content__header}>
            <img data-lang={locale}
              className={styles.wrapper__item__icon2} 
              src={Block2Icon} alt="block 2 icon" />
            <h3>{t('not_only_exchange')}</h3>
          </div>
          <p>{t('invest_borrow_lend_exchange')}</p>
          <ButtonBlue disableHoverColor className={styles.wrapper__item__content__btn} onClick={getStarted}>
            {t('access_all_features')}
          </ButtonBlue>
        </div>
      </div>

      <div className={cn(styles.wrapper__item, styles.wrapper__item_first)}>
        <div className={styles.wrapper__item__content}>
          <div className={styles.wrapper__item__content__header}>
            <img className={styles.wrapper__item__icon3} src={Block3Icon} alt="block 3 icon" />
            <h3>
              <span className={styles.wrapper__item__span3}>24/7</span> {t('support')}
            </h3>
          </div>
          <p>{t('not_left_alone')}</p>
          <ButtonBlue disableHoverColor className={styles.wrapper__item__content__btn} onClick={getStarted}>
            {t('create_account')}
          </ButtonBlue>
        </div>

        <img
          className={styles.wrapper__item__image}
          src={windowWidth > 765 ? Block3Img : Block3ImgMobile}
          alt="block 3 image"
        />
      </div>

      <div className={cn(styles.wrapper__item, styles.wrapper__item_first)}>
        <img className={styles.wrapper__item__image} src={Block4Img} alt="block 4 image" />

        <div className={styles.wrapper__item__content}>
          <div className={styles.wrapper__item__content__header}>
            <img 
              data-lang={locale}
              className={styles.wrapper__item__icon4} 
              src={Block4Icon} alt="block 4 icon" />
            <h3>{t('top_tier_security')}</h3>
          </div>
          <p>
            {t('funds_safety')}
          </p>
          <ButtonBlue disableHoverColor className={styles.wrapper__item__content__btn} onClick={getStarted}>
            {t('deposit_crypto')}
          </ButtonBlue>
        </div>
      </div>
      {isOpenLoginBlock && <LoginForm isWallet={false} onCloseForm={handleClosePopup} type={POPUP_TYPE_LOANS} />}
    </div>
  )
}
